import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as _ser from "../../../_redux/_services/ClientsSlice";
import { setBreadCrumb } from "../../../_utilities/breadCrumb";
import GetJobId from "../../../_utilities/GetJobId";
import ClientsComponent from "../ClientsCreate/ClientsComponent";
import { Height } from "@material-ui/icons";

const initalState = { data: null, message: "", isloader: true };

const ClientsView = () => {
  const getJobCode = GetJobId();
  const dispatch = useDispatch();
  const [getDetails, setGetDetails] = useState(initialDetails);
  const [showNoData, setShowNoData] = useState(false);

  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);

  useEffect(() => {
    let timer;
    if (getDetails?.clientName !== "" && !showLoader && !showUncommonLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 2000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [getDetails?.clientName, showLoader, showUncommonLoader]);

  const actionBtns = [
    {
      variant: "contained",
      label: "Edit",
      type: "back",
      style: {
        backgroundColor: "var(--primary-bg-color)",
        color: "var(--primary-background-text-color)",
        borderRadius: "10px",
        width: "6rem",
        textTransform: "capitalize",
        fontSize: "14px",
      },
      class: "buttonHover1",
      navigateTo: `/ats/layout/clients/edit/${getJobCode}`,
    },
  ];

  useEffect(() => {
    if (getJobCode !== null && getDetails.clientName === "") {
      GetData();
    }
  }, [getJobCode]);

  const onGetValidData = (data) => {
    console.log(data);
  };

  const MyData = useSelector((state) => state.GetClients.data);

  const GetData = async () => {
    dispatch(_ser.getClientsAsync(getJobCode));
  };

  useEffect(() => {
    if (MyData !== null && MyData.length > 0) {
      let myData = JSON.parse(JSON.stringify(MyData));
      setGetDetails(myData[0]);
      dispatch(_ser.getClientsStartReducer(initalState));
      setBreadCrumb(myData[0].id, myData[0].clientName, "clients");
    }
  }, [MyData]);

  return (
    <React.Fragment>
      <div style={{ padding: "0 10px" }} id="clientsView">
        {getDetails?.clientName !== "" ? (
          <ClientsComponent
            componentType="view"
            actions={actionBtns}
            onValidData={onGetValidData}
            input={getDetails}
            iniValue={initialDetails}
          />
        ) : (
          showNoData && (
            <div className="nodatasection">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="noData"
              />
              {"No data found"}
            </div>
          )
        )}
      </div>
    </React.Fragment>
  );
};

export default ClientsView;

const initialDetails = {
  clientName: "",
  // endClient:"",
  managerEmail: "",
  region: "",
  status: "",
  id: "",
  source: 1,
};
